module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/2-bg-7b0bd8d1c207df4d20e834a8ebf1f96e.png";